<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="primary" plain @click="onExport" v-if="!isMB">导出</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.AttendanceId!=0" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-pic-dialog ref="importPicDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/at/logs/list";
import detailsDialog from "@/components/at/logs/detailsDialog";
import editDialog from "@/components/st/student/editDialog";
import importDialog from "@/components/st/student/importDialog";
import importPicDialog from "@/components/st/student/importPicDialog";

export default {
  name: "logs",
  mixins: [curdMixins],
  components: {
    list,
    detailsDialog,
    editDialog,
    importDialog,
    importPicDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onExport() {
      this.$refs.list.onExport();
    },
    details(row) {
      this.$refs.detailsDialog.open().then((that) => {
        that.getData(row);
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.StudentId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>